module.exports = __webpack_public_path__ + "static/media/human.7d5a718a.png";